/**
 * Infinite Optionsの要素がDOMに追加されたことを監視し、引数で渡された関数を実行する関数を作成し、のちにwindowオブジェクトに登録
 * @param {function(NodeList): void} fc
 */
function checkObserver(fc) {
  const containerSelector = '#infiniteoptions-container';
  const labelSelector = '.spb-label-tooltip label';

  const targetNode = document.body;
  const config = {
    childList: true,
    subtree: true
  };

  const callback = (mutationsList, observer) => {
    // コンテナ要素とラベル要素を同時に探す
    const container = document.querySelector(containerSelector);
    if (!container) return; // コンテナが見つからなければ何もしない

    const labels = container.querySelectorAll(labelSelector);
    if (labels.length > 0) {
      // ラベル要素が見つかったら、外部から渡された処理を実行
      fc(labels);
      observer.disconnect(); // 監視を停止
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

window.checkObserver = checkObserver;



/**
 * スムーススクロール
 */
function smoothScroll() {
  const aEl = document.querySelectorAll('a');
  aEl.forEach((a) => {
    a.addEventListener('click', function (e) {
      scrollEvent(this, e);
    });
  });
}

function scrollEvent(aEl, e) {
  if (aEl != null) {
    let href = aEl.getAttribute('href');
    if (href === "#") {
      return;
    }

    if (href != undefined) {
      // lightboxなどリンク以外のa対策;
      if (href.match('#')) {
        const firstbite = href.slice(0, 1);
        // hrefが'#'から始まってたらそのまま格納、そうでなければ加工して格納
        let hrefStr = href;
        if (firstbite === '#') {
          hrefStr = href;
        } else {
          // 絶対パスで同じURLをたたいた時に対応（Wordpress対策）
          let spl = href.split('#');
          //「./」で始まる場合は削除
          if (spl[0].slice(0, 2) === './') {
            spl[0] = location.pathname;
          }
          const url = location.href;
          const urlSpr = url.split('#');
          // 最後に'/'がついてて一致しないときがあるため検査(必要ならこっちに変更)
          // let lastStr = urlSpr[0].slice(-1);
          // let urlString = lastStr === '/' ? urlSpr[0].slice(0,-1) : urlSpr[0];
          const urlString = urlSpr[0];
          // ルートパスに対応
          const pathname = location.pathname;

          if (spl[0] === urlString || spl[0] === pathname) {
            hrefStr = '#' + spl[1];
          } else {
            hrefStr = '';
          }
        }
        if (hrefStr) {
          const offset = aEl.dataset.offset ? Number(aEl.dataset.offset) : 0;
          const speed = aEl.dataset.speed ? Number(aEl.dataset.speed) : 700;
          this.move(hrefStr, offset, speed);
          e.preventDefault();
        }
      }
    }
  } else {
    const hash = location.hash;
    if (hash != '' && hash.length) {
      this.move(hash, 0, 700, true);
    }
  }
}

function move(hash, offset, _speed, _isLoad) {
  const isLoad = _isLoad || false;
  let speed = _speed ? _speed : 700;
  if (isLoad) {
    speed = 0;
  }
  const target = hash === '' ? 'body' : hash;
  const targetEl = document.getElementById(target.replace('#', '')) || document.body;
  if (!targetEl) {
    return false;
  }
  // ヘッダー分の調整;
  const defaultOffset = mediaSp() ? -70 : 0;
  const ofs = offset ? offset : defaultOffset;

  // jump(targetEl, {
  //   duration: speed,
  //   offset: ofs,
  //   callback: undefined,
  //   easing: easeOutExpo,
  //   a11y: false,
  // });

  // JSでスクロール
  const rect = targetEl.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const targetY = rect.top + scrollTop + ofs;

  window.scrollTo({
    top: targetY,
    behavior: 'smooth'
  });
  return false;
}

function mediaSp() {
  let val;
  const mediaQuery = window.matchMedia('(max-width: 767px)');
  handle();
  mediaQuery.addEventListener('change', handle);
  function handle() {
    if (mediaQuery.matches) {
      val = true;
    } else {
      val = false;
    }
  }
  return val;
}

function blogSlider() {
  const targets = document.querySelectorAll('.js-loopCardSlider');

  targets.forEach((target) => {
    new Splide(target, {
      focus: 'center',
      gap: '40px',
      perMove: 1,
      autoWidth: true,
      rewind: false,
      autoplay: true,
      speed: 1000,
      arrows: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      flickMaxPages: 0.5,
      padding: '5rem',
      clones: 4,
      breakpoints: {
        768: {
          padding: '2rem',
          gap: '20px',
        },
      },
    }).mount();
  });
}

window.addEventListener('load', function () {
  if (document.body.classList.contains('page-template')) {
    smoothScroll();
    scrollEvent();
  }
  blogSlider();
});
